import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { getMatrix } from '../actions';
import { getRoute } from '../actions';

class FormularioVrp extends React.Component {

    
    renderError({ error, touched }){
        
        if (touched && error){
            
            return(
                <div className="ui error message">
                    <p>
                        {error}
                    </p>
                </div>
            );
        }
        
    }

    renderInput = (formProps) =>{
        const className = `field ${formProps.meta.error && formProps.meta.touched ? 'error':''}`;
        return(
          <div className={className}>
            <label>{formProps.label}</label>
            <textarea type="text" {...formProps.input} autoComplete="off"/>
            {this.renderError(formProps.meta)}
          </div>        
        );
    }

    onInputSubmit = (formValues) =>{
        this.props.getMatrix(formValues);
    }
    
    render(){
        return(
            <form className="ui form error" onSubmit={this.props.handleSubmit(this.onInputSubmit)}>
                <Field name="coordenadas" component={this.renderInput} label="Enter coordinates"/>
                <button className="ui button primary" type="submit" >Enter</button>
                <button className="ui button"  type="button" disabled={this.props.pristine || this.props.submitting} onClick={this.props.reset}>
                    Clean values
                </button>
            </form>
        )
        
    }
}

const validate_coord = (coord) => {
    
    const coord_split = coord.split(",");
    // izq -2,185068, -79,973175 der  -2,183181, -79,877559 sur -2,269325, -79,899360 nor -2,076425, -79,940811
    if (coord_split[0] < -2.269325 || coord_split[0] > -2.076425){
        return 1;
    } else if (coord_split[1] < -79.973175|| coord_split[1] > -79.877559){
        return 1;       
    };
    return 0;
}

const validate = (formValues) =>{
    
    const errors = {};
    
    if(!formValues.coordenadas){
        errors.coordenadas = "Enter coordinates!"
    } else if(formValues.coordenadas.match(/[&@!?¡¿=(){}|$#%/abcdefghijklmnopqrstuvwyz]/i)){
        errors.coordenadas = "Coordinates entered incorrectly";
    }else if (formValues.coordenadas.length > 0){
        
        const array_coord = formValues.coordenadas.split(";")

        const array_check = array_coord.map(coord => validate_coord(coord))

    if (array_check.includes(1) ){
            errors.coordenadas = "Enter locations only in Guayaquil!";       
        }
    }
    
    return errors
}

const mapStateToProps = (state) => {
    return {response:state.matrix};
}

const formWrapped = reduxForm({
    form:'datosMatrix',
    validate: validate
})(FormularioVrp);

export default connect(mapStateToProps ,{ getMatrix : getMatrix,  getRoute: getRoute })(formWrapped);